import * as React from 'react';

/**
 * @ignore - internal component.
 */
function ToolpadLogo({ size = 40 }: { size?: number }) {
  return (
    <svg
      fill="none"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g mask="url(#a)">
        <path fill="#007FFF" d="M22.74 27.73v-7.6l6.64-3.79v7.6l-6.64 3.79Z" />
        <path fill="#39F" d="M16.1 23.93v-7.59l6.64 3.8v7.59l-6.65-3.8Z" />
        <path
          fill="#A5D8FF"
          d="m16.1 16.34 6.64-3.8 6.64 3.8-6.64 3.8-6.65-3.8Z"
        />
      </g>
      <mask
        x="8"
        id="b"
        y="17"
        width="14"
        height="15"
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path
          fill="#D7DCE1"
          d="M8.5 22.3c0-1.05.56-2 1.46-2.53l3.75-2.14c.89-.5 1.98-.5 2.87 0l3.75 2.14a2.9 2.9 0 0 1 1.46 2.52v4.23c0 1.04-.56 2-1.46 2.52l-3.75 2.14c-.89.5-1.98.5-2.87 0l-3.75-2.14a2.9 2.9 0 0 1-1.46-2.52v-4.23Z"
        />
      </mask>
      <g mask="url(#b)">
        <path fill="#007FFF" d="M15.14 32v-7.6l6.65-3.8v7.6L15.14 32Z" />
        <path fill="#39F" d="M8.5 28.2v-7.6l6.64 3.8V32L8.5 28.2Z" />
        <path
          fill="#A5D8FF"
          d="m8.5 20.6 6.64-3.79 6.65 3.8-6.65 3.8-6.64-3.8Z"
        />
      </g>
      <mask
        x="8"
        y="4"
        id="c"
        width="22"
        height="20"
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path
          fill="#D7DCE1"
          d="M24.17 4.82a2.9 2.9 0 0 0-2.87 0L9.97 11.22a2.9 2.9 0 0 0-1.47 2.53v4.22c0 1.04.56 2 1.46 2.52l3.75 2.14c.89.5 1.98.5 2.87 0l11.33-6.42a2.9 2.9 0 0 0 1.47-2.52V9.48c0-1.04-.56-2-1.46-2.52l-3.75-2.14Z"
        />
      </mask>
      <g mask="url(#c)">
        <path
          fill="#007FFF"
          d="M15.14 23.46v-7.6L29.38 7.8v7.59l-14.24 8.07Z"
        />
        <path fill="#39F" d="M8.5 19.66v-7.6l6.64 3.8v7.6l-6.64-3.8Z" />
        <path
          fill="#A5D8FF"
          d="M8.5 12.07 22.74 4l6.64 3.8-14.24 8.06-6.64-3.8Z"
        />
      </g>
    </svg>
  );
}

export { ToolpadLogo };
